import { render, staticRenderFns } from "./VenueFilter.vue?vue&type=template&id=64bc33d4&scoped=true"
import script from "./VenueFilter.vue?vue&type=script&lang=ts"
export * from "./VenueFilter.vue?vue&type=script&lang=ts"
import style0 from "./VenueFilter.vue?vue&type=style&index=0&id=64bc33d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc33d4",
  null
  
)

export default component.exports